<app-bui-detail-data-item
  [isEditMode]="false"
  [label]="field.label"
  [tooltip]="field.tooltip"
  [isInline]="isInline">
  <ng-template view>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.TEXT">
      <app-custom-field-text-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-text-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.TEXTAREA">
      <app-custom-field-textarea-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-textarea-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.EMAIL">
      <app-custom-field-email-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-email-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.URL">
      <app-custom-field-url-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-url-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.NUMBER">
      <app-custom-field-number-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-number-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.PERCENT">
      <app-custom-field-percent-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-percent-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.PHONE">
      <app-custom-field-phone-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-phone-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.DATE">
      <app-custom-field-date-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-date-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.DATE_TIME">
      <app-custom-field-date-time-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-date-time-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.DATE_PERIOD">
      <app-custom-field-date-period-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-date-period-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.DATE_TIME_PERIOD">
      <app-custom-field-date-time-period-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-date-time-period-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.SWITCHER">
      <app-custom-field-switcher-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-switcher-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.SELECT">
      <app-custom-field-picklist-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-picklist-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.RADIO_BUTTON">
      <app-custom-field-radio-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-radio-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.CHECKBOX">
      <app-custom-field-checkbox-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-checkbox-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.MULTISELECT">
      <app-custom-field-multiselect-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-multiselect-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.NUMERATION">
      <app-custom-field-numeration-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-numeration-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.LOOKUP">
      <app-custom-field-lookup-value-view
        [field]="field"
        [data]="data"
        (click)="$event.stopPropagation()">
      </app-custom-field-lookup-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.LOOKUP_ACTION">
      <app-custom-field-lookup-action-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-lookup-action-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.DECIMAL_NUMBER">
      <app-custom-field-decimal-number-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-decimal-number-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.TIME">
      <app-custom-field-time-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-time-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.ANALITIKE">
      <app-custom-field-analitike-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-analitike-value-view>
    </ng-container>
    <ng-container *ngIf="field.type === CustomFieldTypesEnum.KONTO_ANALITIKE">
      <app-custom-field-konto-analitike-value-view
        [field]="field"
        [data]="data">
      </app-custom-field-konto-analitike-value-view>
    </ng-container>
  </ng-template>
</app-bui-detail-data-item>
